import React, { useMemo } from 'react';
import moment from 'moment';

import useSharedInterval from 'flow/hooks/useSharedInterval';
import { getPrettyDuration } from 'flow/utils/call-utils';

interface Props {
    since?: string | number;
}

const ElapsedTime = ({ since }: Props) => {
    // Parsed once per value rather than on every tick: re-parsing the same
    // string every second can only ever produce the same number.
    const sinceMs = useMemo(
        () => (since ? moment(since).valueOf() : NaN),
        [since],
    );

    // One timer for every ElapsedTime on screen, and nothing ticking while
    // there is no timestamp to count from — moment(undefined) is the current
    // time, which would tick at 0:00 forever.
    useSharedInterval(since ? 1000 : null);

    if (!since) return null;

    return (
        <>
            {
                // Clamped at 0 because getPrettyDuration renders nothing at
                // all for a negative duration, and a future `since` is not
                // exotic: server-supplied timestamps (a queue joinTime) are
                // compared against the local clock.
                getPrettyDuration(
                    moment.duration(Math.max(0, Date.now() - sinceMs)),
                )
            }
        </>
    );
};

export default ElapsedTime;
